<template>
  <el-dialog
    v-drag
    v-loading="loading"
    title="更新BOND信息"
    :visible.sync="dialogVisible"
    width="600px"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
  >
    <div class="content">
      <el-form ref="form" :model="form" label-position="top">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="Surety Code" prop="suretyCode">
              <el-select
                v-model="form.suretyCode"
                filterable
                clearable
                placeholder="请选择"
                style="width: 100%;">
                <el-option label="054" value="054"></el-option>
                <el-option label="856" value="856"></el-option>
                <el-option label="036" value="036"></el-option>
                <el-option label="300" value="300"></el-option>
                <el-option label="846" value="846"></el-option>
                <el-option label="873" value="873"></el-option>
                <el-option label="128" value="128"></el-option>
                <el-option label="664" value="664"></el-option>
                <el-option label="353" value="353"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="买BOND代理" prop="bondSupplierId">
              <el-select
                v-model="form.bondSupplierId"
                placeholder="请选择"
                style="width: 100%;"
                filterable
                clearable>
                <el-option
                  v-for="item in supplierOptions"
                  :key="item.id"
                  :label="item.code + '-' + item.wbName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="BOND Number" prop="bondNumber">
              <el-input
                v-model="form.bondNumber"
                placeholder="请输入"
                style="width: 100%;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="BOND额度" prop="bondTotal">
              <NumberPoint
                v-model="form.bondTotal"
                placeholder="请输入"
                style="width: 100%;"></NumberPoint>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <span slot="footer" class="footers flex_c_c">
      <div class="cancel flex_c_c" @click="cancel">取消</div>
      <div v-debounce-click="{ value: ok, args: ['form'] }" class="ok flex_c_c">
        确定
      </div>
    </span>
  </el-dialog>
</template>

<script>
const NumberPoint = () => import('@/components/base/NumberPoint.vue')
import { batchUpdateBond } from '@/api/system'
export default {
  components: {
    NumberPoint
  },
  props: {
    dialogVisible: Boolean,
    selectionItem: Array,
    supplierOptions: Array
  },
  data() {
    return {
      loading: false,
      form: {
        suretyCode: '',
        bondSupplierId: '',
        bondTotal: '',
        bondNumber: ''
      }
    }
  },
  watch: {
    dialogVisible(v) {
      if (v) {
        this.reset()
      }
    }
  },
  methods: {
    reset() {
      this.form = this.$options.data().form
      this.$refs.form?.resetFields()
    },
    cancel() {
      this.$emit('cancel')
    },
    ok(formName) {
      this.$refs[formName].validate(async(valid) => {
        if (valid) {
          this.loading = true
          try {
            const params = {
              importerIds: this.selectionItem.map(a => a.id),
              ...this.form
            }
            const res = await batchUpdateBond(params)
            this.loading = false
            if (res.success) {
              this.$message.success(res.errorMessage)
              this.$emit('ok')
            } else {
              this.$message.error(res.errorMessage)
            }
          } catch (error) {
            this.loading = false
            console.error(error)
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  width: calc(100% - 40px);
  margin: 0 auto;
  /deep/ .el-form--label-top .el-form-item__label {
    line-height: 30px;
    padding: 0;
  }
}
.footers {
  width: 100%;
  & > div {
    width: 120px;
    height: 40px;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    cursor: pointer;
  }
  .cancel {
    background: #eeeeee;
    color: #666666;
    margin-right: 16px;
  }
  .ok {
    background: #142e79;
    color: #ffffff;
  }
}
</style>
